import { useMemo } from 'react';
import styles from './ProfileBlocksView.module.css';
import BlockCard from '../BlockCard/BlockCard';
import useAllBlocks from '../../hooks/useAllBlocks';
import { sortBlocks } from '@ego/domain';

export default function ProfileBlocksView({ order = 'newest', handle }) {
  const { blocks: allBlocks, loading } = useAllBlocks(handle);

  const sorted = useMemo(
    () => sortBlocks(allBlocks, order),
    [allBlocks, order]
  );

  if (loading) return null;

  if (sorted.length === 0) {
    return <p className={styles.empty}>No blocks yet.</p>;
  }

  return (
    <section className={styles.grid}>
      {sorted.map((block, i) => (
        <BlockCard
          key={`${block.channelHandle}-${block.channelSlug}-${block.id}`}
          block={block}
          channelSlug={block.channelSlug}
          channelHandle={block.channelHandle}
          index={i}
        />
      ))}
    </section>
  );
}
